import React, { useMemo, useState } from "react"
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import { Accordion } from 'react-bootstrap'
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { getLevelRSC, getLongEventRSC } from "helpers/rsc"
import Label, { useLabels } from "components/general/Label"
import Medal from 'components/presentation/Medal';
import TeamBioAnchors from "components/common/participants/TeamBioAnchors"

const getConfiguration = (breakPoint, eventorder) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };
  configuration.sortBy = []
  switch (eventorder) {
    case 'DATE':
      configuration.sortBy = [{ id: 'Time', desc: false }]
      break;
    case 'LOC':
      configuration.sortBy = [{ id: 'Location', desc: false }]
      configuration.disableSort = true
      break;
  }
  configuration.columns = isMobile ? TableColumnsSM() : TableColumns()
  return configuration;
};

const NocMedalsTable = ({ data, eventorder }) => {
  const { breakPoint } = useViewport();
  const config = useMemo(() => getConfiguration(breakPoint, eventorder), [breakPoint]);
  const [paramsUrl, setParamsUrl] = useState({});
  const [shouldNavigate, setShouldNavigate] = useState(false);
  useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, 'results')
  //Prepare URL to navigate
  const params = useUrlFriendlyToParameters()
  let paramsURL = { ...params }
  const fLabel = useLabels();

  const handleClick = (props) => {
    const rsc = props?.eventUnit?.code;
    if (getLevelRSC(paramsURL["mirs_rsc"]) === "EVENT") {
      paramsURL["mirs_event_rsc"] = rsc
      paramsURL["mirs_rsc"] = undefined
    } else {
      //Phase or unit
      paramsURL["mirs_event_rsc"] = getLongEventRSC(rsc)
      paramsURL["mirs_rsc"] = rsc
    }
    setParamsUrl(paramsURL);
  };

  return (
    <div className="bios-personalinfo">
      <TeamBioAnchors data={data} />
      <Accordion className='schedule-container' defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Body className="p-0">
            <MirsTable
              className="table-schedule"
              containerColumnClassName="medals-container-column"
              data={[{ data }]}
              columns={config.columns}
              keyRow='participant-code'
              initialSortBy={config.sortBy}
              rowOnClick={true}
              rowClickHandler={handleClick}
              id={`mirs-table-noc-medallists`}
              showPagination={false}
              // pageSizeCustom={10}
              caption={fLabel({ data: 'HeaderMedalsCurrent' })}
            />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  )
}


export default NocMedalsTable;



function TableColumns() {
  return (
    [
      ColumnRankRowSpan({}),
      ColumnGenderMedals({ gender: 'M' }),
      ColumnGenderMedals({ gender: 'W' }),
      ColumnGenderMedals({ gender: 'X' }),
      ColumnGenderMedals({ gender: 'O' }),
      ColumnGenderMedals({ gender: 'TOT' }),
      ColumnRankTotalRowSpan({}),
    ]
  )
}

function TableColumnsSM() {
  return (
    [
      ColumnRankRowSpan({}),
      ColumnGenderMedals({ gender: 'TOT' }),
      ColumnRankTotalRowSpan({}),
    ]
  )
}

function ColumnRankRowSpan() {
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'Rank',
    headerClassName: "text-center w-5 text-nowrap align-middle",
    id: 'HeaderRank',
    columns: [
      ColumnRank({})
    ]
  }
}

function ColumnRank() {
  return (
    {
      Header: <Label data={"HeaderOrder"} />,
      accessor: 'sortRank',
      className: "text-center",
      headerClassName: "text-center w-5 text-nowrap",
      disableSortBy: true,
      remove: true,
      id: 'Rank',
      Cell: (props) => {
        const row = props.cell.row.original;
        return row?.data?.find(r => r.gender === "TOT")?.rank;
      }
    }
  )
}

function ColumnRankTotalRowSpan() {
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'RankByTotal',
    headerClassName: "text-center w-5",
    id: 'HeaderRankTotal',
    columns: [
      ColumnRankTotal({})
    ]
  }
}

function ColumnRankTotal() {
  return (
    {
      Header: <Label data={"HeaderRankByTotal"} />,
      className: "text-center",
      headerClassName: "text-center w-5",
      disableSortBy: true,
      remove: true,
      id: 'RankByTotal',
      Cell: (props) => {
        const row = props.cell.row.original;
        return row?.data?.find(r => r.gender === "TOT")?.rankTotal;
      }
    }
  )
}


function ColumnGenderMedals({ gender }) {
  let labelText = "";
  switch (gender) {
    case "M":
      labelText = "HeaderMenDesc"
      break;
    case "W":
      labelText = "HeaderWomenDesc"

      break;
    case "X":
      labelText = "HeaderMixedDesc"

      break;
    case "O":
      labelText = "HeaderOpenDesc"

      break;
    case "TOT":
      labelText = "HeaderTOTDesc"

      break;

    default:
      break;
  }
  return {
    id: 'GenderMedals' + gender,
    Header: <Label data={labelText} />,
    headerClassName: "text-center",
    columns: [ColumnMedal({ code: "1", gender }), ColumnMedal({ code: "2", gender }), ColumnMedal({ code: "3", gender }), ColumnMedal({ code: "4", gender })]
  }
}

function ColumnMedal({ code, gender }) {
  let medalType = '';
  let cellId = 'Silver';
  if (code === "1") {
    medalType = 'gold';
    cellId = 'Gold';
  } else if (code === "2") {
    medalType = 'silver';
    cellId = 'Silver';
  } else if (code === "3") {
    medalType = 'bronze';
    cellId = 'Bronze';
  } else if (code === "4") {
    medalType = 'total';
    cellId = 'Total';
  }

  return (
    {
      Header: code === "4" ? <Label data={"HeaderTotal"} /> : <Medal code={code} />,
      className: "text-center",
      headerClassName: "medallist-medal text-center w-5 text-nowrap",
      disableSortBy: true,
      id: cellId + gender,
      Cell: (props) => {
        const res = props.cell.row.original;
        const gendrMedals = res?.data?.find(g => g.gender === gender);
        return gendrMedals?.[medalType];
      }
    }
  )
}


